import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { OverlayTriggerStateContext, Popover, PopoverContext, useSlottedContext, } from 'react-aria-components';
/** Marks every panel of a menu, a submenu's too: a press there is not a press outside. */
const PANEL = 'data-menu-panel';
/**
 * The panel of a menu that leaves the page as it is (after Corly's Popover): non-modal, so no
 * scroll lock, no layer over the page and nothing made inert - the page's scroll bar stays and
 * nothing beneath moves while the menu is open. A modal popover took the bar away, and the
 * table under the menu shifted by its width.
 *
 * What the modal layer did, it does itself: a press outside closes, and so does a press on the
 * trigger of the open menu - without being taken for a new opening. Escape, leaving by focus
 * and scrolling the page close it as React Aria does for a non-modal popover.
 */
export function MenuPopover(props) {
    const state = useContext(OverlayTriggerStateContext);
    const triggerRef = useSlottedContext(PopoverContext)?.triggerRef;
    const isOpen = state?.isOpen ?? false;
    useEffect(() => {
        if (!isOpen || !state)
            return;
        const onPointerDown = (event) => {
            const target = event.target;
            if (!(target instanceof Element) || target.closest(`[${PANEL}]`))
                return;
            if (triggerRef?.current?.contains(target)) {
                // The trigger would open again on this press; it closes instead, as a toggle.
                event.preventDefault();
                event.stopPropagation();
            }
            state.close();
        };
        // Capturing, before the trigger's own handlers see the press.
        document.addEventListener('pointerdown', onPointerDown, true);
        return () => document.removeEventListener('pointerdown', onPointerDown, true);
    }, [isOpen, state, triggerRef]);
    return _jsx(Popover, { ...props, isNonModal: true, [PANEL]: '' });
}
/**
 * The entry of a menu or list that has the keyboard's focus: the tint shows the pointer, the ring
 * the keyboard - a tint of 7 % alone is too faint to find (WCAG 2.4.7).
 */
export const menuItemFocusClassName = 'data-focus-visible:outline-2 data-focus-visible:-outline-offset-2 data-focus-visible:outline-focus';
//# sourceMappingURL=menu-popover.js.map